/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UsersRouteImport } from './routes/users'
import { Route as StylingRouteImport } from './routes/styling'
import { Route as ServiceHealthRouteImport } from './routes/service-health'
import { Route as ScreensRouteImport } from './routes/screens'
import { Route as OverviewRouteImport } from './routes/overview'
import { Route as LoginRouteImport } from './routes/login'
import { Route as FunnelsRouteImport } from './routes/funnels'
import { Route as ErrorsRouteImport } from './routes/errors'
import { Route as IndexRouteImport } from './routes/index'
import { Route as StylingIndexRouteImport } from './routes/styling.index'
import { Route as ScreensIndexRouteImport } from './routes/screens.index'
import { Route as FunnelsIndexRouteImport } from './routes/funnels.index'
import { Route as StylingTimingRouteImport } from './routes/styling.timing'
import { Route as StylingStylistActivityRouteImport } from './routes/styling.stylist-activity'
import { Route as StylingSkuAnalysisRouteImport } from './routes/styling.sku-analysis'
import { Route as StylingOverviewRouteImport } from './routes/styling.overview'
import { Route as StylingFilterPatternsRouteImport } from './routes/styling.filter-patterns'
import { Route as StylingErrorsRouteImport } from './routes/styling.errors'
import { Route as ScreensScreenNameRouteImport } from './routes/screens.$screenName'
import { Route as FunnelsFunnelIdRouteImport } from './routes/funnels.$funnelId'

const UsersRoute = UsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => rootRouteImport,
} as any)
const StylingRoute = StylingRouteImport.update({
  id: '/styling',
  path: '/styling',
  getParentRoute: () => rootRouteImport,
} as any)
const ServiceHealthRoute = ServiceHealthRouteImport.update({
  id: '/service-health',
  path: '/service-health',
  getParentRoute: () => rootRouteImport,
} as any)
const ScreensRoute = ScreensRouteImport.update({
  id: '/screens',
  path: '/screens',
  getParentRoute: () => rootRouteImport,
} as any)
const OverviewRoute = OverviewRouteImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const FunnelsRoute = FunnelsRouteImport.update({
  id: '/funnels',
  path: '/funnels',
  getParentRoute: () => rootRouteImport,
} as any)
const ErrorsRoute = ErrorsRouteImport.update({
  id: '/errors',
  path: '/errors',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const StylingIndexRoute = StylingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StylingRoute,
} as any)
const ScreensIndexRoute = ScreensIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ScreensRoute,
} as any)
const FunnelsIndexRoute = FunnelsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => FunnelsRoute,
} as any)
const StylingTimingRoute = StylingTimingRouteImport.update({
  id: '/timing',
  path: '/timing',
  getParentRoute: () => StylingRoute,
} as any)
const StylingStylistActivityRoute = StylingStylistActivityRouteImport.update({
  id: '/stylist-activity',
  path: '/stylist-activity',
  getParentRoute: () => StylingRoute,
} as any)
const StylingSkuAnalysisRoute = StylingSkuAnalysisRouteImport.update({
  id: '/sku-analysis',
  path: '/sku-analysis',
  getParentRoute: () => StylingRoute,
} as any)
const StylingOverviewRoute = StylingOverviewRouteImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => StylingRoute,
} as any)
const StylingFilterPatternsRoute = StylingFilterPatternsRouteImport.update({
  id: '/filter-patterns',
  path: '/filter-patterns',
  getParentRoute: () => StylingRoute,
} as any)
const StylingErrorsRoute = StylingErrorsRouteImport.update({
  id: '/errors',
  path: '/errors',
  getParentRoute: () => StylingRoute,
} as any)
const ScreensScreenNameRoute = ScreensScreenNameRouteImport.update({
  id: '/$screenName',
  path: '/$screenName',
  getParentRoute: () => ScreensRoute,
} as any)
const FunnelsFunnelIdRoute = FunnelsFunnelIdRouteImport.update({
  id: '/$funnelId',
  path: '/$funnelId',
  getParentRoute: () => FunnelsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/errors': typeof ErrorsRoute
  '/funnels': typeof FunnelsRouteWithChildren
  '/login': typeof LoginRoute
  '/overview': typeof OverviewRoute
  '/screens': typeof ScreensRouteWithChildren
  '/service-health': typeof ServiceHealthRoute
  '/styling': typeof StylingRouteWithChildren
  '/users': typeof UsersRoute
  '/funnels/$funnelId': typeof FunnelsFunnelIdRoute
  '/screens/$screenName': typeof ScreensScreenNameRoute
  '/styling/errors': typeof StylingErrorsRoute
  '/styling/filter-patterns': typeof StylingFilterPatternsRoute
  '/styling/overview': typeof StylingOverviewRoute
  '/styling/sku-analysis': typeof StylingSkuAnalysisRoute
  '/styling/stylist-activity': typeof StylingStylistActivityRoute
  '/styling/timing': typeof StylingTimingRoute
  '/funnels/': typeof FunnelsIndexRoute
  '/screens/': typeof ScreensIndexRoute
  '/styling/': typeof StylingIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/errors': typeof ErrorsRoute
  '/login': typeof LoginRoute
  '/overview': typeof OverviewRoute
  '/service-health': typeof ServiceHealthRoute
  '/users': typeof UsersRoute
  '/funnels/$funnelId': typeof FunnelsFunnelIdRoute
  '/screens/$screenName': typeof ScreensScreenNameRoute
  '/styling/errors': typeof StylingErrorsRoute
  '/styling/filter-patterns': typeof StylingFilterPatternsRoute
  '/styling/overview': typeof StylingOverviewRoute
  '/styling/sku-analysis': typeof StylingSkuAnalysisRoute
  '/styling/stylist-activity': typeof StylingStylistActivityRoute
  '/styling/timing': typeof StylingTimingRoute
  '/funnels': typeof FunnelsIndexRoute
  '/screens': typeof ScreensIndexRoute
  '/styling': typeof StylingIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/errors': typeof ErrorsRoute
  '/funnels': typeof FunnelsRouteWithChildren
  '/login': typeof LoginRoute
  '/overview': typeof OverviewRoute
  '/screens': typeof ScreensRouteWithChildren
  '/service-health': typeof ServiceHealthRoute
  '/styling': typeof StylingRouteWithChildren
  '/users': typeof UsersRoute
  '/funnels/$funnelId': typeof FunnelsFunnelIdRoute
  '/screens/$screenName': typeof ScreensScreenNameRoute
  '/styling/errors': typeof StylingErrorsRoute
  '/styling/filter-patterns': typeof StylingFilterPatternsRoute
  '/styling/overview': typeof StylingOverviewRoute
  '/styling/sku-analysis': typeof StylingSkuAnalysisRoute
  '/styling/stylist-activity': typeof StylingStylistActivityRoute
  '/styling/timing': typeof StylingTimingRoute
  '/funnels/': typeof FunnelsIndexRoute
  '/screens/': typeof ScreensIndexRoute
  '/styling/': typeof StylingIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/errors'
    | '/funnels'
    | '/login'
    | '/overview'
    | '/screens'
    | '/service-health'
    | '/styling'
    | '/users'
    | '/funnels/$funnelId'
    | '/screens/$screenName'
    | '/styling/errors'
    | '/styling/filter-patterns'
    | '/styling/overview'
    | '/styling/sku-analysis'
    | '/styling/stylist-activity'
    | '/styling/timing'
    | '/funnels/'
    | '/screens/'
    | '/styling/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/errors'
    | '/login'
    | '/overview'
    | '/service-health'
    | '/users'
    | '/funnels/$funnelId'
    | '/screens/$screenName'
    | '/styling/errors'
    | '/styling/filter-patterns'
    | '/styling/overview'
    | '/styling/sku-analysis'
    | '/styling/stylist-activity'
    | '/styling/timing'
    | '/funnels'
    | '/screens'
    | '/styling'
  id:
    | '__root__'
    | '/'
    | '/errors'
    | '/funnels'
    | '/login'
    | '/overview'
    | '/screens'
    | '/service-health'
    | '/styling'
    | '/users'
    | '/funnels/$funnelId'
    | '/screens/$screenName'
    | '/styling/errors'
    | '/styling/filter-patterns'
    | '/styling/overview'
    | '/styling/sku-analysis'
    | '/styling/stylist-activity'
    | '/styling/timing'
    | '/funnels/'
    | '/screens/'
    | '/styling/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ErrorsRoute: typeof ErrorsRoute
  FunnelsRoute: typeof FunnelsRouteWithChildren
  LoginRoute: typeof LoginRoute
  OverviewRoute: typeof OverviewRoute
  ScreensRoute: typeof ScreensRouteWithChildren
  ServiceHealthRoute: typeof ServiceHealthRoute
  StylingRoute: typeof StylingRouteWithChildren
  UsersRoute: typeof UsersRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/users': {
      id: '/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof UsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/styling': {
      id: '/styling'
      path: '/styling'
      fullPath: '/styling'
      preLoaderRoute: typeof StylingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/service-health': {
      id: '/service-health'
      path: '/service-health'
      fullPath: '/service-health'
      preLoaderRoute: typeof ServiceHealthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/screens': {
      id: '/screens'
      path: '/screens'
      fullPath: '/screens'
      preLoaderRoute: typeof ScreensRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/overview': {
      id: '/overview'
      path: '/overview'
      fullPath: '/overview'
      preLoaderRoute: typeof OverviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/funnels': {
      id: '/funnels'
      path: '/funnels'
      fullPath: '/funnels'
      preLoaderRoute: typeof FunnelsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/errors': {
      id: '/errors'
      path: '/errors'
      fullPath: '/errors'
      preLoaderRoute: typeof ErrorsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/styling/': {
      id: '/styling/'
      path: '/'
      fullPath: '/styling/'
      preLoaderRoute: typeof StylingIndexRouteImport
      parentRoute: typeof StylingRoute
    }
    '/screens/': {
      id: '/screens/'
      path: '/'
      fullPath: '/screens/'
      preLoaderRoute: typeof ScreensIndexRouteImport
      parentRoute: typeof ScreensRoute
    }
    '/funnels/': {
      id: '/funnels/'
      path: '/'
      fullPath: '/funnels/'
      preLoaderRoute: typeof FunnelsIndexRouteImport
      parentRoute: typeof FunnelsRoute
    }
    '/styling/timing': {
      id: '/styling/timing'
      path: '/timing'
      fullPath: '/styling/timing'
      preLoaderRoute: typeof StylingTimingRouteImport
      parentRoute: typeof StylingRoute
    }
    '/styling/stylist-activity': {
      id: '/styling/stylist-activity'
      path: '/stylist-activity'
      fullPath: '/styling/stylist-activity'
      preLoaderRoute: typeof StylingStylistActivityRouteImport
      parentRoute: typeof StylingRoute
    }
    '/styling/sku-analysis': {
      id: '/styling/sku-analysis'
      path: '/sku-analysis'
      fullPath: '/styling/sku-analysis'
      preLoaderRoute: typeof StylingSkuAnalysisRouteImport
      parentRoute: typeof StylingRoute
    }
    '/styling/overview': {
      id: '/styling/overview'
      path: '/overview'
      fullPath: '/styling/overview'
      preLoaderRoute: typeof StylingOverviewRouteImport
      parentRoute: typeof StylingRoute
    }
    '/styling/filter-patterns': {
      id: '/styling/filter-patterns'
      path: '/filter-patterns'
      fullPath: '/styling/filter-patterns'
      preLoaderRoute: typeof StylingFilterPatternsRouteImport
      parentRoute: typeof StylingRoute
    }
    '/styling/errors': {
      id: '/styling/errors'
      path: '/errors'
      fullPath: '/styling/errors'
      preLoaderRoute: typeof StylingErrorsRouteImport
      parentRoute: typeof StylingRoute
    }
    '/screens/$screenName': {
      id: '/screens/$screenName'
      path: '/$screenName'
      fullPath: '/screens/$screenName'
      preLoaderRoute: typeof ScreensScreenNameRouteImport
      parentRoute: typeof ScreensRoute
    }
    '/funnels/$funnelId': {
      id: '/funnels/$funnelId'
      path: '/$funnelId'
      fullPath: '/funnels/$funnelId'
      preLoaderRoute: typeof FunnelsFunnelIdRouteImport
      parentRoute: typeof FunnelsRoute
    }
  }
}

interface FunnelsRouteChildren {
  FunnelsFunnelIdRoute: typeof FunnelsFunnelIdRoute
  FunnelsIndexRoute: typeof FunnelsIndexRoute
}

const FunnelsRouteChildren: FunnelsRouteChildren = {
  FunnelsFunnelIdRoute: FunnelsFunnelIdRoute,
  FunnelsIndexRoute: FunnelsIndexRoute,
}

const FunnelsRouteWithChildren =
  FunnelsRoute._addFileChildren(FunnelsRouteChildren)

interface ScreensRouteChildren {
  ScreensScreenNameRoute: typeof ScreensScreenNameRoute
  ScreensIndexRoute: typeof ScreensIndexRoute
}

const ScreensRouteChildren: ScreensRouteChildren = {
  ScreensScreenNameRoute: ScreensScreenNameRoute,
  ScreensIndexRoute: ScreensIndexRoute,
}

const ScreensRouteWithChildren =
  ScreensRoute._addFileChildren(ScreensRouteChildren)

interface StylingRouteChildren {
  StylingErrorsRoute: typeof StylingErrorsRoute
  StylingFilterPatternsRoute: typeof StylingFilterPatternsRoute
  StylingOverviewRoute: typeof StylingOverviewRoute
  StylingSkuAnalysisRoute: typeof StylingSkuAnalysisRoute
  StylingStylistActivityRoute: typeof StylingStylistActivityRoute
  StylingTimingRoute: typeof StylingTimingRoute
  StylingIndexRoute: typeof StylingIndexRoute
}

const StylingRouteChildren: StylingRouteChildren = {
  StylingErrorsRoute: StylingErrorsRoute,
  StylingFilterPatternsRoute: StylingFilterPatternsRoute,
  StylingOverviewRoute: StylingOverviewRoute,
  StylingSkuAnalysisRoute: StylingSkuAnalysisRoute,
  StylingStylistActivityRoute: StylingStylistActivityRoute,
  StylingTimingRoute: StylingTimingRoute,
  StylingIndexRoute: StylingIndexRoute,
}

const StylingRouteWithChildren =
  StylingRoute._addFileChildren(StylingRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ErrorsRoute: ErrorsRoute,
  FunnelsRoute: FunnelsRouteWithChildren,
  LoginRoute: LoginRoute,
  OverviewRoute: OverviewRoute,
  ScreensRoute: ScreensRouteWithChildren,
  ServiceHealthRoute: ServiceHealthRoute,
  StylingRoute: StylingRouteWithChildren,
  UsersRoute: UsersRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
